/* Crocpad Claims Form logic — externalized from sections/claims-form.liquid (2026-06-09).
   Shopify strips inline <script> from rendered sections, so this loads as a theme ASSET
   (served from Shopify CDN, not sanitized). Referenced from the section via:
     {{ 'claims-form.js' | asset_url | script_tag }}   (placed after the form markup).
   Same working logic as the storefront embed — keep selectors (.cpf-prod-card / .cpf-ch-card,
   data-value, ids) and the POST endpoint in sync with the section HTML. Binds on DOMContentLoaded.
 */
function cpfInit(){
  let cur=1;const files=[];
  let selectedProduct=null;
  let selectedChannel=null;
  let allProducts=[];
  const $=id=>document.getElementById(id);

  // Map a category card label to keywords used to filter the product list by
  // its Shopify product_type / name. Optional: if no products match the category
  // (or product_type is empty across the catalog) we fall back to showing all.
  const CATEGORY_KEYWORDS={
    'Ice Bath':['ice bath','cold plunge'],
    'Chiller':['chiller'],
    'Inflatable Slide':['slide'],
    'Dog Ramp':['dog'],
    'Water Mat':['water mat','floating mat','floating water mat','beer pong','saddle','sliding mat'],
    'Dry Bag':['dry bag'],
    'Other':[]
  };
  function matchesCategory(p, cat){
    if(!cat||cat==='Other') return true;
    const keys=CATEGORY_KEYWORDS[cat]||[];
    if(!keys.length) return true;
    const hay=((p.name||'')+' '+(p.product_type||'')).toLowerCase();
    return keys.some(function(k){return hay.indexOf(k)!==-1});
  }
  function renderProductDropdown(){
    const sel=$('cpf-pname');
    if(!sel) return;
    const list=allProducts.length
      ? allProducts.filter(function(p){return matchesCategory(p, selectedProduct)})
      : [];
    const useFiltered=list.length>0;
    const items=useFiltered?list:allProducts;
    const prev=sel.value;
    sel.innerHTML='<option value="">— Select product —</option>'+
      items.map(function(p){return '<option value="'+esc(p.name)+'">'+esc(p.name)+'</option>'}).join('');
    if(prev&&items.some(function(p){return p.name===prev})) sel.value=prev;
    sel.disabled=items.length===0;
  }
  // Fire-and-forget; the field is optional so failure here must not block submission.
  fetch('https://hub.crocpad.com/api/support/products?brand_id=7',{mode:'cors',credentials:'omit'})
    .then(function(r){return r.json()})
    .then(function(d){
      if(d&&Array.isArray(d.products)) allProducts=d.products;
      renderProductDropdown();
    })
    .catch(function(){
      const sel=$('cpf-pname');
      if(sel){sel.innerHTML='<option value="">— Select product —</option>';sel.disabled=false;}
    });

  // Product cards — wired via addEventListener (Shopify CSP/TinyMCE strips inline onclick)
  document.querySelectorAll('.crocpad-claim-form .cpf-prod-card').forEach(function(card){
    card.addEventListener('click',function(){
      selectedProduct=this.dataset.value;
      document.querySelectorAll('.crocpad-claim-form .cpf-prod-card').forEach(function(c){c.classList.remove('cpf-selected')});
      this.classList.add('cpf-selected');
      const e=$('cpf-e-prod');if(e)e.style.display='none';
      const f=$('cpf-f-prod');if(f)f.classList.remove('fe');
      renderProductDropdown();
    });
    card.addEventListener('keydown',function(e){
      if(e.key===' '||e.key==='Enter'){e.preventDefault();this.click()}
    });
  });

  // Channel cards — same pattern. Store-name field shows only for Clark
  // Rubber (the one channel where customers walk into a physical store and
  // we need the store location). Harvey Norman is online-only.
  const STORE_LABEL_CHANNELS={store:1};
  document.querySelectorAll('.crocpad-claim-form .cpf-ch-card').forEach(function(card){
    card.addEventListener('click',function(){
      selectedChannel=this.dataset.value;
      document.querySelectorAll('.crocpad-claim-form .cpf-ch-card').forEach(function(c){c.classList.remove('cpf-selected')});
      this.classList.add('cpf-selected');
      const store=$('cpf-f-store');
      if(store)store.style.display=STORE_LABEL_CHANNELS[selectedChannel]?'block':'none';
      const e=$('cpf-e-ch');if(e)e.style.display='none';
      const f=$('cpf-f-ch');if(f)f.classList.remove('fe');
    });
    card.addEventListener('keydown',function(e){
      if(e.key===' '||e.key==='Enter'){e.preventDefault();this.click()}
    });
  });

  $('cpf-cdet').addEventListener('input',function(){$('cpf-ccn').textContent=this.value.length});
  $('cpf-fi').addEventListener('change',e=>addF(e.target.files));
  const dz=$('cpf-dz');
  dz.addEventListener('click',e=>{if(e.target.tagName!=='INPUT')$('cpf-fi').click()});
  dz.addEventListener('dragover',e=>{e.preventDefault();dz.classList.add('over')});
  dz.addEventListener('dragleave',()=>dz.classList.remove('over'));
  dz.addEventListener('drop',e=>{e.preventDefault();dz.classList.remove('over');addF(e.dataTransfer.files)});
  $('cpf-bbk').addEventListener('click',bk);
  $('cpf-bnx').addEventListener('click',nx);
  const reloadBtn=$('cpf-reload');
  if(reloadBtn)reloadBtn.addEventListener('click',function(){window.location.reload()});

  function addF(f){Array.from(f).forEach(x=>{if(!files.find(y=>y.name===x.name))files.push(x)});rF()}
  function rF(){
    $('cpf-fl').innerHTML=files.map((f,i)=>`<div class="fitem"><span class="fi">${ic(f)}</span><span class="fn">${esc(f.name)}</span><span class="fs">${sz(f.size)}</span><button type="button" class="fx" data-idx="${i}">×</button></div>`).join('');
    $('cpf-fl').querySelectorAll('.fx').forEach(b=>b.addEventListener('click',()=>{files.splice(parseInt(b.dataset.idx,10),1);rF()}));
  }
  function ic(f){return f.type.startsWith('image/')?'🖼️':f.type.startsWith('video/')?'🎥':f.type==='application/pdf'?'📄':'📎'}
  function sz(b){return b<1024?b+' B':b<1048576?(b/1024).toFixed(1)+' KB':(b/1048576).toFixed(1)+' MB'}
  function esc(s){return String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}

  function nx(){if(!val(cur))return;if(cur===4){sub();return}if(cur===3)bldRv();cur++;rdr()}
  function bk(){if(cur>1){cur--;rdr()}}
  function rdr(){
    document.querySelectorAll('.crocpad-claim-form .panel').forEach(p=>p.classList.remove('active'));
    $('cpf-p'+cur).classList.add('active');
    window.scrollTo({top:0,behavior:'smooth'});
    for(let i=1;i<=4;i++){
      const n=$('cpf-sn'+i),l=$('cpf-sl'+i);
      n.classList.remove('active','done');l.classList.remove('active','done');
      if(i<cur){n.classList.add('done');l.classList.add('done');n.textContent='✓'}
      else if(i===cur){n.classList.add('active');l.classList.add('active');n.textContent=String(i)}
      else{n.textContent=String(i)}
    }
    for(let i=1;i<=3;i++){const ln=$('cpf-ln'+i);if(ln)ln.style.width=i<cur?'100%':'0%'}
    $('cpf-bbk').classList.toggle('inv',cur===1);
    $('cpf-bnx').innerHTML=cur===4?'Submit Claim <svg viewBox="0 0 16 16" fill="none" style="width:13px;height:13px"><path d="M2 8l4 4 8-8" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>':'Continue <svg viewBox="0 0 16 16" fill="none" style="width:13px;height:13px"><path d="M6 3l5 5-5 5" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }
  function val(s){
    let ok=true;
    if(s===1){
      se('cpf-e-prod',selectedProduct===null);if(selectedProduct===null)ok=false;
      ok=rq('cpf-f-ord','cpf-onum')&&ok;ok=rq('cpf-f-dt','cpf-pdt')&&ok;
      se('cpf-e-ch',selectedChannel===null);if(selectedChannel===null)ok=false;
      if(STORE_LABEL_CHANNELS[selectedChannel])ok=rq('cpf-f-store','cpf-sname')&&ok;
    }
    if(s===2){ok=rq('cpf-f-tt','cpf-ctitle')&&ok;const d=$('cpf-cdet').value.trim();er('cpf-f-det',d.length<30);if(d.length<30)ok=false}
    if(s===3){
      ok=rq('cpf-f-fn','cpf-fname-first')&&ok;
      ok=rq('cpf-f-ln','cpf-fname-last')&&ok;
      const e=$('cpf-femail').value.trim();const ev=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);er('cpf-f-em',!ev);if(!ev)ok=false;
      ok=rq('cpf-f-mob','cpf-fmob')&&ok;ok=rq('cpf-f-a1','cpf-a1')&&ok;ok=rq('cpf-f-sub','cpf-sub')&&ok;ok=rq('cpf-f-st','cpf-sta')&&ok;ok=rq('cpf-f-pc','cpf-pcode')&&ok;
    }
    return ok;
  }
  function rq(fid,iid){const v=$(iid).value.trim().length>0;er(fid,!v);return v}
  function er(fid,has){$(fid).classList.toggle('fe',has)}
  function se(id,vis){$(id).style.display=vis?'block':'none'}
  const CHANNEL_NAMES={direct:'Crocpad Direct',amazon:'Amazon / eBay',store:'Retail store'};
  function bldRv(){
    const pr=selectedProduct||'—';
    const cv=selectedChannel||'';
    const channelName=CHANNEL_NAMES[cv]||cv||'—';
    const purchasedFrom=STORE_LABEL_CHANNELS[cv]
      ? (channelName + ' — ' + ($('cpf-sname').value.trim()||'(store location not specified)'))
      : channelName;
    const ad=[$('cpf-a1').value,$('cpf-a2').value,$('cpf-sub').value,$('cpf-sta').value,$('cpf-pcode').value,$('cpf-cntry').value].filter(Boolean).join(', ')||'—';
    const fullName=[$('cpf-fname-first').value.trim(),$('cpf-fname-last').value.trim()].filter(Boolean).join(' ')||'—';
    const pnEl=$('cpf-pname');const specific=(pnEl?pnEl.value:'').trim();
    $('cpf-rvg').innerHTML=`
      <div class="rvc"><div class="rvcl">Product</div><div class="rvcv">${esc(pr)}</div></div>
      ${specific?`<div class="rvc"><div class="rvcl">Specific Product</div><div class="rvcv">${esc(specific)}</div></div>`:''}
      <div class="rvc"><div class="rvcl">Order Number</div><div class="rvcv">${esc($('cpf-onum').value||'—')}</div></div>
      <div class="rvc"><div class="rvcl">Purchase Date</div><div class="rvcv">${esc($('cpf-pdt').value||'—')}</div></div>
      <div class="rvc"><div class="rvcl">Purchased From</div><div class="rvcv">${esc(purchasedFrom)}</div></div>
      <div class="rvc wide"><div class="rvcl">Claim Title</div><div class="rvcv">${esc($('cpf-ctitle').value||'—')}</div></div>
      <div class="rvc wide"><div class="rvcl">Claim Details</div><div class="rvcv body">${esc($('cpf-cdet').value||'—')}</div></div>
      <div class="rvc"><div class="rvcl">Name</div><div class="rvcv">${esc(fullName)}</div></div>
      <div class="rvc"><div class="rvcl">Email</div><div class="rvcv">${esc($('cpf-femail').value||'—')}</div></div>
      <div class="rvc"><div class="rvcl">Mobile</div><div class="rvcv">${esc($('cpf-fmob').value||'—')}</div></div>
      <div class="rvc"><div class="rvcl">Attachments</div><div class="rvcv">${files.length>0?files.length+' file(s)':'None'}</div></div>
      <div class="rvc wide"><div class="rvcl">Shipping Address</div><div class="rvcv">${esc(ad)}</div></div>`;
  }

  const API_ENDPOINT='https://hub.crocpad.com/api/support/claims?brand_id=7';

  function sub(){
    const btn=$('cpf-bnx');
    const origHTML=btn.innerHTML;
    btn.disabled=true;
    btn.innerHTML='Submitting…';

    const channel=selectedChannel||'';
    // store_name is captured only for physical retail channels — for the rest we
    // send the channel display name so the hub can show a single "Purchased From"
    // line without special-casing each value.
    const storeName=STORE_LABEL_CHANNELS[channel]
      ?($('cpf-sname').value||'').trim()
      :(CHANNEL_NAMES[channel]||'');

    // SUPPORT-MODULE-2026-05-03: multipart/form-data so actual file bytes upload.
    // Browser sets Content-Type with boundary automatically — do NOT set it manually.
    const fd=new FormData();
    fd.append('product',          selectedProduct||'');
    const pnEl2=$('cpf-pname');
    fd.append('product_name',     (pnEl2?pnEl2.value:'').trim());
    fd.append('order_number',     $('cpf-onum').value.trim());
    fd.append('purchase_date',    $('cpf-pdt').value);
    fd.append('purchase_channel', channel);
    fd.append('store_name',       storeName);
    fd.append('claim_title',      $('cpf-ctitle').value.trim());
    fd.append('claim_details',    $('cpf-cdet').value.trim());
    fd.append('first_name',       $('cpf-fname-first').value.trim());
    fd.append('last_name',        $('cpf-fname-last').value.trim());
    fd.append('email',            $('cpf-femail').value.trim());
    fd.append('mobile',           $('cpf-fmob').value.trim());
    fd.append('address_line1',    $('cpf-a1').value.trim());
    fd.append('address_line2',    $('cpf-a2').value.trim());
    fd.append('suburb',           $('cpf-sub').value.trim());
    fd.append('state',            $('cpf-sta').value);
    fd.append('postcode',         $('cpf-pcode').value.trim());
    fd.append('country',          $('cpf-cntry').value);
    files.forEach(function(f){ fd.append('files', f, f.name); });

    fetch(API_ENDPOINT,{
      method:'POST',
      mode:'cors',
      body:fd
    })
      .then(r=>r.json().then(j=>({ok:r.ok,status:r.status,body:j})))
      .then(res=>{
        if(!res.ok||!res.body||res.body.success!==true){
          const msg=(res.body&&(res.body.error||res.body.message))||('HTTP '+res.status);
          throw new Error(msg);
        }
        const ref=res.body.claim_ref||('CP-'+Math.floor(10000+Math.random()*90000));
        document.querySelectorAll('.crocpad-claim-form .panel').forEach(p=>p.classList.remove('active'));
        $('cpf-fnav').style.display='none';
        $('cpf-sref').textContent='Claim #'+ref;
        $('cpf-suc').classList.add('show');
        for(let i=1;i<=4;i++){
          const n=$('cpf-sn'+i),l=$('cpf-sl'+i);
          n.classList.remove('active');n.classList.add('done');n.textContent='✓';
          l.classList.remove('active');l.classList.add('done');
        }
        for(let i=1;i<=3;i++)$('cpf-ln'+i).style.width='100%';
      })
      .catch(err=>{
        btn.disabled=false;
        btn.innerHTML=origHTML;
        alert('Sorry — your claim could not be submitted. Please try again or email us at support@crocpad.com.au.\n\nError: '+err.message);
      });
  }
}
/* Boot only when the claims form is actually on the page, so this asset is safe to
   load from anywhere (gated head, ungated head, or section) without throwing on
   pages that have no form. */
function cpfBoot(){ if(document.querySelector('.crocpad-claim-form')) cpfInit(); }
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',cpfBoot);
}else{
  cpfBoot();
}
